import { render, staticRenderFns } from "./MctChart.vue?vue&type=template&id=1899ef20&"
import script from "./MctChart.vue?vue&type=script&lang=js&"
export * from "./MctChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports